import { withSvgIcon } from './withSvgIcon';

export const ArrowRightBig = withSvgIcon(
  <path
    d="M13 19L20 12M20 12L13 5M20 12L5 12"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
